export default {
  'common.select.placeholder': '请选择',
  'common.enabled': '启用',
  'common.disabled': '禁用',
  'common.select.actStatus.disabled': '禁用',
  'common.select.actStatus.enabled': '启用',
  'common.select.actStatus.ended': '结束',
  'common.select.gameType.slot': '电子',
  'common.select.gameType.live': '真人',
  'common.select.gameType.sport': '体育',
  'common.select.gameType.lottery': '彩票',
  'common.select.gameType.fish': '捕鱼',
  'common.select.gameType.chess': '棋牌',
  'common.select.gameType.minigame': '小游戏',
  'common.select.gameType.xlive': '竞猜',
  'common.select.gameType.esports': '电竞',
  'common.select.gameType.arcade': '街机',
  'common.select.gameType.bingo': '宾果',
  'common.select.gameType.unknown': '未知',
  'common.select.pointAwardStatus.claimed': '已领取',
  'common.select.pointAwardStatus.expired': '已过期',
  'common.select.actTemplateType.rebate': '投注返水',
  'common.select.actTemplateType.custom': '自定义优惠',
  'common.select.actTemplateType.realtimeRebate': 'VIP游戏返水',
  'common.select.actTemplateType.register': '注册优惠',
  'common.select.actTemplateType.dailyFirstRecharge': '每日首充',
  'common.select.actTemplateType.recharge': '充值优惠',
  'common.select.actTemplateType.loginRecharge': '登入充值抽奖',
  'common.select.actTemplateType.luckySpin': '大转盘',
  'common.select.actTemplateType.everyRecharge': '笔笔存款',
  'common.select.actTemplateType.invite': '邀请好友',
  'common.select.actTemplateType.infoBinding': '信息绑定优惠',
  'common.select.actTemplateType.redPacketRain': '红包雨',
  'common.select.actTemplateType.firstDeposit': '首存优惠',
  'common.select.actTemplateType.newRebate': '新返水优惠',
  'common.select.manualSendUserStatus.notStarted': '未开始',
  'common.select.manualSendUserStatus.processing': '处理中',
  'common.select.manualSendUserStatus.success': '成功',
  'common.select.manualSendUserStatus.failed': '失败',
  'common.select.manualSendStatus.notStarted': '未开始',
  'common.select.manualSendStatus.processing': '处理中',
  'common.select.manualSendStatus.completed': '已完成',
  'common.select.awardType.cash': '现金',
  'common.select.awardType.points': '积分',
  'common.select.awardType.fuel': '推进货币',
  'common.select.actName.vipReward': 'VIP奖励',
  'common.select.actName.fissionActivity': '裂变活动',
  'common.select.balanceSubType.deposit': '充值',
  'common.select.balanceSubType.withdraw': '提现',
  'common.select.balanceSubType.manualSend': '人工发放',
  'common.select.balanceSubType.upgradeReward': '升级礼金',
  'common.select.balanceSubType.retentionReward': '保级礼金',
  'common.select.balanceSubType.weeklySalary': '周俸禄',
  'common.select.balanceSubType.monthlySalary': '月俸禄',
  'common.select.balanceSubType.birthdayReward': '生日礼金',
  'common.select.balanceSubType.upgradePoint': '升级积分',
  'common.select.balanceSubType.retentionPoint': '保级积分',
  'common.select.balanceSubType.appDayPoint': 'APP端每日积分',
  'common.select.balanceSubType.h5DayPoint': 'H5端每日积分',
  'common.select.balanceSubType.realtimeRebate': 'VIP游戏返水奖励',
  'common.select.balanceSubType.rebate': '返水奖励',
  'common.select.balanceSubType.registerBonus': '注册奖励',
  'common.select.balanceSubType.rechargeBonus': '存款优惠',
  'common.select.balanceSubType.dailyFirstRechargeBonus': '每日首存优惠',
  'common.select.balanceSubType.loginRechargeLoginBonus': '登入',
  'common.select.balanceSubType.loginRechargeRechargeBonus': '充值',
  'common.select.balanceSubType.redemptionCodeBonus': '兑换码优惠',
  'common.select.balanceSubType.luckySpinBonus': '大转盘奖励',
  'common.select.balanceSubType.everyRechargeBonus': '笔笔存优惠',
  'common.select.balanceSubType.inviteBonus': '邀请奖励',
  'common.select.balanceSubType.inviteAchievementBonus': '成就奖励',
  'common.select.balanceSubType.inviteeBonus': '被邀请奖励',
  'common.select.balanceSubType.infoBindingBonus': '信息绑定优惠',
  'common.select.balanceSubType.chickTreasureBoxBonus': '宝箱奖励',
  'common.select.balanceSubType.chickCheckinBonus': '签到奖励',
  'common.select.balanceSubType.redPacketRain': '红包雨',
  'common.select.balanceSubType.treasureBoxDailyBonus': '每日宝箱派发',
  'common.select.balanceSubType.newRebateBonus': '新返水优惠',
  'common.select.balanceSubType.firstDepositBonus': '首存优惠',
  'common.select.balanceSubType.vendorLeaderboardBonus': '排行榜活动奖励',
  'common.select.balanceSubType.inviteDepositRebateBonus': '邀请充值返佣',
  'common.select.balanceSubType.inviteBetRebateBonus': '邀请投注返佣',
  'common.select.balanceSubType.inviteWinLossRebateBonus': '邀请输赢返佣',
  'common.select.balanceSubType.inviteNgrRebateBonus': '邀请NGR返佣',
  'common.select.balanceSubType.manualDeposit': '人工存入',
  'common.select.balanceSubType.gameTransferIn': '游戏转入',
  'common.select.balanceSubType.gameTransferOut': '游戏转出',
  'common.select.balanceSubType.pointExchange': '积分兑换',
  'common.select.balanceSubType.actRechargeFuel': '充值加油',
  'common.select.balanceSubType.actInviteFuel': '邀请加油',
  'common.select.balanceSubType.actJeepneyEnterReward': '入场奖励',
  'common.select.balanceSubType.actJeepneyStageReward': '闯关奖励',

  'common.select.balanceSubType.upgradeTicket': '升级參與券',
  'common.select.balanceSubType.weeklyTicket': '周俸禄參與券',
  'common.select.balanceSubType.monthlyTicket': '月俸禄參與券',
  'common.select.balanceSubType.birthdayTicket': '生日參與券',
  'common.select.balanceSubType.appDailyTicket': 'app每日參與券',
  'common.select.balanceSubType.h5DailyTicket': 'h5每日參與券',
  'common.select.balanceSubType.weeklyPoint': '周俸禄积分',
  'common.select.balanceSubType.monthlyPoint': '月俸禄积分',
  'common.select.balanceSubType.birthdayPoint': '生日积分',
  'common.select.balanceSubType.retentionTicket': '保级參與券',
  'common.select.balanceSubType.appDailyPoint': 'app每日积分',
  'common.select.balanceSubType.h5DailyPoint': 'h5每日积分',
};
